export const matchUrl = (match: string | RegExp, input: string) =>
  match instanceof RegExp ? match.test(input) : input.includes(match);

export const matchAll = (match: (string | RegExp)[], input: string) =>
  match.every((x) => matchUrl(x, input));

export const matchNone = (match: (string | RegExp)[], input: string) =>
  match.every((x) => !matchUrl(x, input));
